export default "__VITE_ASSET__4tdpHUgxsjM2BVMh2n1Y5Q__"